export const groupsTranslationEn = {
    title: "Groups",
    fields: {
        name: "Name",
    },
};
